import React, {useState} from 'react'
import './Slider.css'
import BtnSlider from './BtnSlider'
import dataSlider from './dataSlider'
import styled from 'styled-components';
import p from '../img2/img2.jpeg';
import pp from '../img2/img4.jpeg';
import n2 from '../img2/img6.jpeg'
import n3 from '../img2/img5.jpeg'
import { Container,Table , Button } from 'react-bootstrap';





// עיצוב עדכני לקונטיינר הראשי
const MainWrapper = styled.section`
  padding: 4rem 2rem;
  font-family: 'Assistant', sans-serif;
  direction: rtl;
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1560px;
  margin: 0 auto 5rem auto;
`;

const ProjectCard = styled.div`
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  border: 1px solid #edf2f7;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  }

  img {
    width: 100%;
    height: 500px;
    object-fit: cover;
    border-bottom: 1px solid #f1f5f9;
  }

  .content {
    padding: 1.5rem;
    text-align: center;
  }

  h3 {
    margin: 0.5rem 0;
    font-size: 1.4rem;
    color: #1a202c;
    background: linear-gradient(90deg, #2563eb, #7c3aed);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    color: #64748b;
    font-size: 0.9rem;
  }
`;

export default function UpdatedSlider() {
    const [slideIndex, setSlideIndex] = useState(1);

    const projects = [
        { id: 1, title: "S.G one ניקיון ואחזקות", url: "https://sg1.co.il/", img: pp, desc: "עובדי ניקיון וצוותי ניקיון" },
        { id: 2, title: "רישוי עסקים ישראל", url: "https://rishuy-asakim.co.il", img: p, desc: "ליווי מקצועי לרישוי עסקים" },
        { id: 3, title: "אוחנה MMA ", url: "https://teamohanamma.co.il/", img: n2, desc: "אומנות לחימה כדרך חיים " },
        { id: 4, title: "  איטומים בגבהים", url: "https://www.itumimb.co.il/", img: n3, desc: "  איטומים בגבהים קבלן לשיקום מבנים איטום גגות ועבודות סנפלינג" }
    ];

    return (
        <MainWrapper>

            {/* כרטיסיות הפרויקטים - מחליף את ה-GPT3 Possibility הישן */}
            <ProjectsGrid>
                {projects.map(project => (
                    <ProjectCard key={project.id} onClick={() => window.open(project.url, '_blank')}>
                        <img src={project.img} alt={project.title} />
                        <div className="content">
                            <h3>{project.title}</h3>
                            <p>{project.desc}</p>
                            <span style={{color: '#3b82f6', fontWeight: 'bold', fontSize: '0.8rem'}}>לחץ לצפייה באתר ←</span>
                        </div>
                    </ProjectCard>
                ))}
            </ProjectsGrid>

            {/* כאן נכנס הסליידר שלך - מומלץ לעטוף אותו בקונטיינר עם Border Radius */}
            <div className="modern-slider-container" style={{ borderRadius: '25px', overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.1)' }}>
                {/* קוד הסליידר הקיים שלך... */}
            </div>
        </MainWrapper>
    );
}





/////<div onClick={Moving}  style={{backgroundColor:"#DCE1E3" ,marginLeft:"auto",marginRight:"auto" ,marginBottom:"auto",marginTop:"auto" }} className="flip-box"  >
 //// <Card.Img onClick={Moving}    variant="center" src={pp} />

////</div>


 ////<div className="gpt3__possibiWhoarewe section__padding" id="possibiWhoarewe"  style={{backgroundColor:"#DCE1E3" ,marginLeft:"auto",marginRight:"auto" ,marginBottom:"auto",marginTop:"auto" }} className="flip-box"   >
  ///<Card.Img    variant="center" src={p} />
///
////</div>